import type { FC, JSX } from "react";
import React from "react";

import { IconSizeErrorBoundary } from "../../../../../HOCs/IconSizeErrorBoundary";
import { Icon } from "../../../../Icon";
import { TAG_DISPLAY_NAME } from "../../Tag";

import type { IconProps } from "../../../../Icon";
import type { ITag } from "../../Tag";

import tagClasses from "../../Tag.styl";

const TAG_ICON_TEST_ID = "tag-icon-test-id";

interface ITagIconMain {
    size: IconProps["size"];
    tagSize: Exclude<ITag["size"], undefined>;
}

interface ITagIcon extends Pick<IconProps, "icon"> {}

const TagIcon: FC<ITagIcon> = (props): JSX.Element => {
    const { tagSize, icon, size } = props as ITagIcon & ITagIconMain;

    return (
        <IconSizeErrorBoundary
            componentName={TAG_DISPLAY_NAME}
            componentSize={tagSize}
            iconName={icon}
            iconSize={size}
        >
            <Icon
                {...(props as IconProps)}
                className={tagClasses.icon}
                data-tsid={TAG_ICON_TEST_ID}
            />
        </IconSizeErrorBoundary>
    );
};

TagIcon.displayName = "Tag.Icon";

export default TagIcon;
